export const dailyViewRoutes = [
  {
    name: 'dailyView',
    path: '/daily-view',
    component: () => import('@/modules/daily-view/views/LocationDailyView.vue')
  }
]
